import { BellOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Badge, Button, Tooltip } from 'antd'
import { useNavigate } from 'react-router'

import { alertsApi } from '../api/endpoints'

export const ALERT_SUMMARY_REFRESH_MS = 30_000

/** Header bell: count of open critical + warning alerts. */
export function AlertBadge() {
  const navigate = useNavigate()
  const summary = useQuery({ queryKey: ['alerts-summary'], queryFn: alertsApi.summary, refetchInterval: ALERT_SUMMARY_REFRESH_MS })
  const s = summary.data
  const count = s ? s.critical + s.warning : 0
  const title = s ? `${s.critical} nghiêm trọng · ${s.warning} cảnh báo` : 'Cảnh báo'
  return (
    <Tooltip title={title}>
      <Badge count={count} color={s && s.critical > 0 ? 'red' : 'orange'} size="small" overflowCount={99}>
        <Button type="text" icon={<BellOutlined />} onClick={() => void navigate('/alerts')} aria-label={`Cảnh báo (${count})`} />
      </Badge>
    </Tooltip>
  )
}
